export default () => document.createElement('video');
